import { useLeagueTableQuery } from '@data/leagueTables/useLeagueTableQuery';
import type { LeagueTableRecord } from '@repo/types';

const MAX_ROWS = 6;

export function NavMegaTable({ competitionId }: { competitionId?: string }) {
  const { data: table, isLoading, error } = useLeagueTableQuery({ competitionId });

  if (isLoading || error) {
    return null;
  }
  if (!table?.data || table.data.length === 0) {
    return null;
  }

  return (
    <div className="nav__mega-comp">
      <h6 className="nav__mega-title">{table.competition?.name ?? 'League table'}</h6>
      <table className="nav__mtable text-3xs">
        <thead>
          <tr>
            <th className="nav__mtable-num">#</th>
            <th>Team</th>
            <th className="nav__mtable-num">P</th>
            <th className="nav__mtable-num">GD</th>
            <th className="nav__mtable-num">Pts</th>
          </tr>
        </thead>
        <tbody>
          {table.data.slice(0, MAX_ROWS).map((row: LeagueTableRecord) => (
            <tr key={row.team.id}>
              <td className="nav__mtable-num">{row.position}</td>
              <td>{row.team.shortName || row.team.fullName}</td>
              <td className="nav__mtable-num">{row.total.played}</td>
              <td className="nav__mtable-num">
                {row.total.goalDifference > 0 ? `+${row.total.goalDifference}` : row.total.goalDifference}
              </td>
              <td className="nav__mtable-num nav__mtable-pts">{row.adjustedPoints ?? row.points}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
